import { render } from "./Tree.vue?vue&type=template&id=4741d2d8&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=4741d2d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4741d2d8"

export default script